<template>
    <div>
        <b-menu>
            <b-menu-list label="Ordenar por">
                <b-select @input="orderChange" v-model="selectedOrdering" expanded>
                    <option value="price">Mas barato primero.</option>
                    <option value="-price">Mas caro primero.</option>
                    <option value="title">A-Z</option>
                    <option value="-title">Z-A</option>
                </b-select>
            </b-menu-list>
            <b-menu-list label="Categorias" v-if="showCategorias">
                <b-collapse
                    v-for="cat in categories"
                    v-if="cat.hideEmpty"
                    :key="cat.id"
                    animation="slide"
                    class="m-b-15"
                    :open="false">
                    <div class="level is-mobile"
                    slot="trigger"
                    slot-scope="props"
                    role="button">
                        <div class="level-left">
                            <span class="has-text-weight-bold">{{cat.title}}</span>
                        </div>
                        <div class="level-right">
                            <b-icon
                                :icon="props.open ? 'times' : 'plus'"
                                size="is-small">
                            </b-icon>
                        </div>
                    </div>
                    <div class="bordered-level">
                        <div class="content">
                            <a class="heading has-text-weight-bold" :href="cat.getProdListUrl">Ver todos >>></a>
                            <a class="heading p-0 m-0" v-for="sub in cat.subcategories" :key="sub.id" :href="sub.getProdListUrl">{{sub.title}}</a>
                        </div>
                    </div>
                </b-collapse>
            </b-menu-list>
            <b-menu-list v-if="availableFilters.length" label="Filtros">
                <div v-for="x in availableFilters" :key="x.id" class="m-b-15">
                    <p class="has-text-weight-bold m-b-5">
                        {{x.title}}
                    </p>
                    
                    <b-checkbox 
                        type="is-dark"
                        v-for="opt in x.options" 
                        :key="opt.id"
                        size="is-small"
                        v-model="selectedFiltersList"
                        :native-value="opt.id"
                        @input="updateFilters">
                        {{opt.title}}
                    </b-checkbox>
                
                </div>
            </b-menu-list>
        </b-menu>
    </div>
</template>

<script>
import {getHandler} from "./../../../../services/http.js"

export default {
    props:{
        categoriesUrl:{
            type:String,
            default:""
        },
        selectedOrdering:{
            type:String,
            default:""
        },
        availableFilters:{
            type:Array,
            default: new Array([])
        },
        selectedFiltersList:{
            type:Array,
            default: new Array([])
        }
    },
    data(){
        return{
            categories:[],
            categoriesLoading:false,
        }
    },
    computed:{
        showCategorias(){
            if (window.innerWidth < 768){
                return false
            } else{
                return true
            }
            
        }
    },
    methods:{
        async fetchCategories(){
            this.categoriesLoading = true
            this.categories = await getHandler(this.categoriesUrl, {error:false, success:false})
            this.categoriesLoading = false
        },
        orderChange(){
            this.$emit("changedOrder", this.selectedOrdering)
        },
        updateFilters(){
            this.$emit("updatedFilter", this.selectedFiltersList)
        }
    },
    created(){
        this.fetchCategories()
    }
}
</script>
<style lang="scss" scoped>
.bordered-level{
    border-left: 0.8px solid rgb(200, 200, 200);
}



</style>